import {Injectable} from '@angular/core';
import {Prediction} from './prediction/prediction';
import {WIZARD_ROUTES} from '../pages/wizard/wizard-routes';
import {PredictionClass} from './prediction-class';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() {
  }

  getRoutingPageFrom(jtp: Prediction): string {
    if (jtp.request_new_picture) {
      return WIZARD_ROUTES.UNKNOWN_PAGE;
    }

    if (jtp.prediction_class === PredictionClass.CHANGE) {
      return WIZARD_ROUTES.REPLACE_PAGE;
    }

    if (jtp.prediction_class === PredictionClass.NO_ACTION) {
      return WIZARD_ROUTES.NO_ACTION_PAGE;
    }

    return WIZARD_ROUTES.REPAIR_PAGE;
  }
}
